import { useCallback, useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CreateGameOptionButton from "./CreateGameOptionButton";
import Newsie from "../../../../Components/Games/Newsie";
import { GAMES } from "../../../../Util/constants";

import "./CreateGames.css";
import WordSearch from "../../../../Components/Games/WordSearch";
import Crossword from "../../../../Components/Games/Crossword";
import Quiz from "../../../../Components/Games/Quiz";
import { resetPuzzle, setPuzzleType } from "Store/features/puzzleSlice";

import CollectContentForm from "./CollectContentForm";

import CreateGamesContainer from "./CreateGamesContainer";

// const CREATE_GAMES_SCREENS = {
//   ...GAMES,
//   SELECT_GAME: "select_game",
// };

const CreateGames = (props) => {
  // SOT - Persisted Puzzle
  const puzzle = useSelector((state) => state.puzzleSlice.puzzle);
  const puzzleSlice = useSelector((state) => state.puzzleSlice);
  const edit = puzzleSlice?.edit;
  // Local Changes
  const [puzzleTitle, setPuzzleTitle] = useState(puzzleSlice?.title || null);

  const [wordsearchWordsInput, setWordsearchWordsInput] = useState(
    puzzle?.words || []
  );
  const [contentRecieved, setContentRecieved] = useState(
    Boolean(puzzle) || false
  );
  const [crosswordWordsInput, setCrosswordWordsInput] = useState(
    puzzle?.words || []
  );

  const [draftPuzzle, setDraftPuzzle] = useState(puzzle || null);

  useEffect(() => {
    if (puzzle) {
      setDraftPuzzle(puzzle);
    }
  }, [puzzle]);

  const { puzzleType, onClickExitCreateGames } = props;

  const dispatch = useDispatch();

  const handleSelectGameType = useCallback(
    (type) => {
      dispatch(setPuzzleType(type));
    },
    [setPuzzleType, dispatch]
  );

  const handleClickBack = useCallback(
    (type) => {
      dispatch(resetPuzzle());

      // Reset State
      setContentRecieved(false);
      setCrosswordWordsInput([]);
      setDraftPuzzle(null);
      setPuzzleTitle(null);
    },
    [setPuzzleType, dispatch]
  );


  const handleWordsearchContent = useCallback((title, words) => {
    setPuzzleTitle(title);
    setWordsearchWordsInput(words);
    setContentRecieved(true);
  }, []);

  const handleCrosswordContent = useCallback((title, words) => {
    console.log({ title, words });
    setPuzzleTitle(title);
    setCrosswordWordsInput(words);
    setContentRecieved(true);
  }, []);

  const handleNewsieContent = useCallback((title, newsie) => {
    setPuzzleTitle(title);
    setDraftPuzzle(newsie);
    setContentRecieved(true);
  }, []);

  const handleQuizContent = useCallback((title, quiz) => {
    setPuzzleTitle(title);
    setDraftPuzzle(quiz);
    setContentRecieved(true);
  }, []);

  // const CreateGamesContainer = useMemo(() => {
  //   if (!puzzleType)
  //     return () => (
  //       <div>
  //         <div className="choose-your-puzzle-directive-container">
  //           Choose a puzzle
  //         </div>
  //         <div className="create-games-row-selector-container">
  //           <CreateGameOptionButton
  //             game={GAMES.NEWSIE}
  //             onSelectGameType={handleSelectGameType}
  //           />
  //           <CreateGameOptionButton
  //             game={GAMES.WORDSEARCH}
  //             onSelectGameType={handleSelectGameType}
  //           />
  //           <CreateGameOptionButton
  //             game={GAMES.CROSSWORD}
  //             onSelectGameType={handleSelectGameType}
  //           />
  //           <CreateGameOptionButton
  //             game={GAMES.QUIZ}
  //             onSelectGameType={handleSelectGameType}
  //             justIcon={false}
  //           />
  //         </div>
  //       </div>
  //     );
  //   if (puzzleType && !contentRecieved)
  //     return () => (
  //       <CollectContentForm
  //         puzzleType={puzzleType}
  //         onClickExitCreateGames={onClickExitCreateGames}
  //         onWordsearchContent={handleWordsearchContent}
  //         onCrosswordContent={handleCrosswordContent}
  //         onNewsieContent={handleNewsieContent}
  //         onQuizContent={handleQuizContent}
  //       />
  //     );
  //   if (puzzleType === CREATE_GAMES_SCREENS.NEWSIE)
  //     return () => (
  //       <Newsie
  //         puzzleTitle={puzzleTitle}
  //         onClickBack={handleClickBack}
  //         draftNewsie={draftPuzzle}
  //       />
  //     );
  //   if (puzzleType === CREATE_GAMES_SCREENS.WORDSEARCH)
  //     return () => (
  //       <WordSearch
  //         puzzleTitle={puzzleTitle}
  //         wordsInput={wordsearchWordsInput}
  //         size={10}
  //         onClickBack={handleClickBack}
  //       />
  //     );
  //   if (puzzleType === CREATE_GAMES_SCREENS.QUIZ) {
  //     console.log('rerenderPuzzle');
  //     return () => (
  //       <Quiz onClickBack={handleClickBack} draftPuzzle={draftPuzzle} puzzleTitle={puzzleTitle}/>
  //     );
  //   }

  //   if (puzzleType === CREATE_GAMES_SCREENS.CROSSWORD)
  //     return () => (
  //       <Crossword
  //         puzzleTitle={puzzleTitle}
  //         onClickBack={handleClickBack}
  //         draftWordsAndClues={crosswordWordsInput}
  //         edit={edit}
  //       />
  //     );
  //   // Should This be here
  //   return () => <></>;
  // }, [
  //   puzzleTitle,
  //   draftPuzzle,
  //   crosswordWordsInput,
  //   contentRecieved,
  //   wordsearchWordsInput,
  //   onClickExitCreateGames,
  //   puzzleType,
  //   handleSelectGameType,
  //   handleClickBack,
  //   handleCrosswordContent,
  //   handleNewsieContent,
  //   handleWordsearchContent,
  //   handleQuizContent,
  // ]);

  return (
    <div className="create-games-container">
      {!puzzleType ? (
        <div className="create-games-container-exit-row-container">
          <div
            className="create-games-screen-exit-button"
            onClick={onClickExitCreateGames}
          >
            X
          </div>
        </div>
      ) : null}

      <CreateGamesContainer
        puzzleType={puzzleType}
        onClickExitCreateGames={onClickExitCreateGames}
        handleWordsearchContent={handleWordsearchContent}
        handleCrosswordContent={handleCrosswordContent}
        handleNewsieContent={handleNewsieContent}
        handleQuizContent={handleQuizContent}
        handleSelectGameType={handleSelectGameType}
        handleClickBack={handleClickBack}
        draftPuzzle={draftPuzzle}
        crosswordWordsInput={crosswordWordsInput}
        contentRecieved={contentRecieved}
        wordsearchWordsInput={wordsearchWordsInput}
        puzzleTitle={puzzleTitle}
        edit={edit}
      />
    </div>
  );
};

export default CreateGames;
